// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BETypeElement } from './BETypeElement';
import { EnumDTPType } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumDTPType';
import { BEComponent } from './BEComponent';
import { DTAttribute } from './DTAttribute';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { BEDistributedTransactionExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/BEDistributedTransactionExtend';
/**
 * 分布式事务 实体类
 * 分布式事务
 */
export class BEDistributedTransaction extends BETypeElement {
  /** 返回数据类型 : 返回数据类型，无返回使用void */
  private _returnDataType: EnumDataType;

  /** 设置：返回数据类型 */
  public get returnDataType() {
    return this._returnDataType;
  }

  /** 获取：返回数据类型 */
  public set returnDataType(value: EnumDataType) {
    this._returnDataType = value;
  }

  /** 返回值引用类型 : 返回值引用类型，当数据类型为引用类型时有效 */
  private _returnReferenceType: string;

  /** 设置：返回值引用类型 */
  public get returnReferenceType() {
    return this._returnReferenceType;
  }

  /** 获取：返回值引用类型 */
  public set returnReferenceType(value: string) {
    this._returnReferenceType = value;
  }

  /** 返回值描述 : 返回值描述 */
  private _returnDescription: string;

  /** 设置：返回值描述 */
  public get returnDescription() {
    return this._returnDescription;
  }

  /** 获取：返回值描述 */
  public set returnDescription(value: string) {
    this._returnDescription = value;
  }

  /** 是否是集合 : 返回值是否是集合 */
  private _returnIsCollection: boolean;

  /** 设置：是否是集合 */
  public get returnIsCollection() {
    return this._returnIsCollection;
  }

  /** 获取：是否是集合 */
  public set returnIsCollection(value: boolean) {
    this._returnIsCollection = value;
  }

  /** 是否分页 : 返回值是否是否分页 */
  private _returnIsPaged: boolean;

  /** 设置：是否分页 */
  public get returnIsPaged() {
    return this._returnIsPaged;
  }

  /** 获取：是否分页 */
  public set returnIsPaged(value: boolean) {
    this._returnIsPaged = value;
  }

  /** 协议类型 : 协议类型，目前仅支持TCC */
  private _protocolType: EnumDTPType;

  /** 设置：协议类型 */
  public get protocolType() {
    return this._protocolType;
  }

  /** 获取：协议类型 */
  public set protocolType(value: EnumDTPType) {
    this._protocolType = value;
  }

  /** 是否幂等 : 是否支持幂等性，幂等可多次调用不影响结果，幂等支持可能引起性能下降 */
  private _isIdempotence: boolean;

  /** 设置：是否幂等 */
  public get isIdempotence() {
    return this._isIdempotence;
  }

  /** 获取：是否幂等 */
  public set isIdempotence(value: boolean) {
    this._isIdempotence = value;
  }

  /** 超时时间 : 事务超时时间，单位秒 */
  private _timeout: number;

  /** 设置：超时时间 */
  public get timeout() {
    return this._timeout;
  }

  /** 获取：超时时间 */
  public set timeout(value: number) {
    this._timeout = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 分布式事务属性 */
  private _attributes: Array<DTAttribute>;

  /** 获取：分布式事务属性 */
  public get attributes() {
    return this._attributes;
  }

  /** 设置：分布式事务属性 */
  public set attributes(value: Array<DTAttribute>) {
    this._attributes = value;
  }

  constructor() {
    super();
    BEDistributedTransactionExtend.Init(this);
    this._returnDataType = EnumDataType.String;
    this._returnReferenceType = '';
    this._returnDescription = '';
    this._returnIsCollection = false;
    this._returnIsPaged = false;
    this._protocolType = EnumDTPType.TCC;
    this._isIdempotence = false;
    this._timeout = 0;
    this._component_ID = '';
    this._component = null;
    this._attributes = new Array<DTAttribute>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEDistributedTransaction, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.returnDataType = element.returnDataType;
      this.returnReferenceType = element.returnReferenceType;
      this.returnDescription = element.returnDescription;
      this.returnIsCollection = element.returnIsCollection;
      this.returnIsPaged = element.returnIsPaged;
      this.protocolType = element.protocolType;
      this.isIdempotence = element.isIdempotence;
      this.timeout = element.timeout;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.returnDataType = json.ReturnDataType as EnumDataType;
    this.returnReferenceType = json.ReturnReferenceType;
    this.returnDescription = json.ReturnDescription;
    this.returnIsCollection = json.ReturnIsCollection;
    this.returnIsPaged = json.ReturnIsPaged;
    this.protocolType = json.ProtocolType as EnumDTPType;
    this.isIdempotence = json.IsIdempotence;
    this.timeout = json.Timeout;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    if (json.Attributes && json.Attributes.length > 0) {
      json.Attributes.forEach((element: any) => {
        const dTAttribute = DTAttribute.Create(element);
        // dTAttribute.distributedTransaction = this;
        this.attributes.push(dTAttribute);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ReturnDataType = this.returnDataType;
    json.ReturnReferenceType = this.returnReferenceType;
    json.ReturnDescription = this.returnDescription;
    json.ReturnIsCollection = this.returnIsCollection;
    json.ReturnIsPaged = this.returnIsPaged;
    json.ProtocolType = this.protocolType;
    json.IsIdempotence = this.isIdempotence;
    json.Timeout = this.timeout;
    json.Component_ID = this.component_ID;
    if (this.attributes && this.attributes.length > 0) {
      json.Attributes = [];
      this.attributes.forEach((element) => {
        json.Attributes.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('返回值', 'returnDataType', '返回数据类型', EnumDataType.Reference, this.returnDataType, true, '返回数据类型，无返回使用void', 'EnumDataType', 'PGRowEnumValue');
    context.addRow('返回值', 'returnReferenceType', '返回值引用类型', EnumDataType.String, this.returnReferenceType, true, '返回值引用类型，当数据类型为引用类型时有效', '', 'PGRowDataTypeValue:all');
    context.addRow('返回值', 'returnDescription', '返回值描述', EnumDataType.String, this.returnDescription, true, '返回值描述', '', '');
    context.addRow('返回值', 'returnIsCollection', '是否是集合', EnumDataType.Bool, this.returnIsCollection, true, '返回值是否是集合', '', '');
    context.addRow('返回值', 'returnIsPaged', '是否分页', EnumDataType.Bool, this.returnIsPaged, true, '返回值是否是否分页', '', '');
    context.addRow('代码属性', 'protocolType', '协议类型', EnumDataType.Reference, this.protocolType, true, '协议类型，目前仅支持TCC', 'EnumDTPType', 'PGRowEnumValue');
    context.addRow('代码属性', 'isIdempotence', '是否幂等', EnumDataType.Bool, this.isIdempotence, true, '是否支持幂等性，幂等可多次调用不影响结果，幂等支持可能引起性能下降', '', '');
    context.addRow('代码属性', 'timeout', '超时时间', EnumDataType.Int, this.timeout, true, '事务超时时间，单位秒', '', '');
    return context;
  }

  static Create(json: any): BEDistributedTransaction {
    const bEDistributedTransaction = new BEDistributedTransaction();
    bEDistributedTransaction.Deserialize(json);
    bEDistributedTransaction.json = json;
    return bEDistributedTransaction;
  }
}
